import { useMemo } from 'react';
import { SummaryCard } from '@/components/common';
import { useTranslations } from '@/hooks';

/**
 * Props:
 *   shipment  the processShipmentForAddDeclarations view model
 */
export const ShipmentContextBar = ({ shipment }) => {
  const t = useTranslations();

  const fields = useMemo(
    () => [
      { label: t('FIELD_RECEIVED_AT'), value: shipment.facilityName },
      // TODO: inboundType is a ShipmentFilters input only, not a BatchGroup field yet.
      { label: t('FIELD_INBOUND_TYPE'), value: '-' },
      { label: t('FIELD_MATERIAL_NAME'), value: shipment.materialName },
      {
        label: t('FORM_MULTI_SITE_TRANSFER'),
        value: shipment.multiSiteTransfer ? t('COMMON_YES') : t('COMMON_NO'),
      },
      { label: t('FIELD_SUPPLIER_NAME'), value: shipment.supplierName },
      { label: t('FIELD_DECLARATION_UNIT'), value: shipment.declarationUnit },
      { label: t('FIELD_ACTUAL_SHIPMENT_QUANTITY'), value: shipment.shipmentQuantity },
      { label: t('FIELD_AVAILABLE_QUANTITY'), value: shipment.availableQuantity },
      { label: t('FIELD_PENDING_QUANTITY'), value: shipment.pendingQuantity },
      { label: t('FIELD_DATE_OF_DISPATCH'), value: shipment.dateOfDispatch },
      {
        label: t('FIELD_TOTAL_CONTRACTS_LINKED'),
        value: String(shipment.totalContractsLinked),
      },
      {
        label: t('FIELD_TOTAL_DECLARATIONS_LINKED'),
        value: String(shipment.totalDeclarationsLinked),
      },
    ],
    [t, shipment],
  );

  return <SummaryCard fields={fields} columns={6} />;
};
